import styles from "./index.module.css";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJs,
  CategoryScale,
  BarElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getVehicleCountByMonth } from "../../../redux/features/dashboard/dashboardService";

ChartJs.register(
  CategoryScale,
  BarElement,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ quantity, chartTitle }) => {
  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
        },
        ticks: {
          stepSize: 100,
        },
      },
    },
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardTopic}>
        <p className={styles.title}>{chartTitle}</p>
      </div>
      <div className={styles.barChart}>
          <Bar
            options={options}
            data={{
              labels: quantity?.map((item) => item.month) || [],
              datasets: [
                {
                  label: "Quantity",
                  backgroundColor: "#DE895D",
                  barThickness: 20,
                  borderRadius: 4,
                  borderSkipped: false,
                  data: quantity?.map((item) => Number(item.count)) || [],
                },
              ],
            }}
          />
      </div>
    </div>
  );
};

export default BarChart;